// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"b9942ece","165":"eeac945c","195":"60be3ca9","411":"87c018aa","673":"483d15ad","773":"f0477e31","974":"95fdf579"}[chunkId] + ".chunk.js";
};